import GeneralActionTypes from './general.types';

export const resetAllReducerStateStart = () => ({
	type: GeneralActionTypes.RESET_ALL_REDUCER_STATE_START,
});

export const isEditDetailsStart = (isEdit: any) => ({
	type: GeneralActionTypes.IS_EDIT_DETAILS_START,
	payload: isEdit,
});

export const isOpenCanvasStart = (isOpen: any) => ({
	type: GeneralActionTypes.IS_OPEN_OFFCANVAS_START,
	payload: isOpen,
});

/** ***************** GET COUNTRY START *********************** */
export const getCountryListStart = () => ({
	type: GeneralActionTypes.GET_COUNTRY_LIST_START,
});

export const getCountryListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_COUNTRY_LIST_SUCCESS,
	payload: successData,
});

export const getCountryListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_COUNTRY_LIST_FAILURE,
	payload: failureData,
});

export const getCountryListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_RESET,
});

export const getCountryListResponseChanged = () => ({
	type: GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_CHANGED,
});
/** ***************** GET COUNTRY END *********************** */

/** ***************** GET STATE START *********************** */
export const getStateListStart = (stateData: any) => ({
	type: GeneralActionTypes.GET_STATE_LIST_START,
	payload: stateData,
});

export const getStateListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_STATE_LIST_SUCCESS,
	payload: successData,
});

export const getStateListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_STATE_LIST_FAILURE,
	payload: failureData,
});

export const getStateListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_STATE_LIST_RESPONSE_RESET,
});

export const getStateListResponseChanged = () => ({
	type: GeneralActionTypes.GET_STATE_LIST_RESPONSE_CHANGED,
});
/** ***************** GET STATE END *********************** */

/** ***************** GET CITY START *********************** */
export const getCityListStart = (cityData: any) => ({
	type: GeneralActionTypes.GET_CITY_LIST_START,
	payload: cityData,
});

export const getCityListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_CITY_LIST_SUCCESS,
	payload: successData,
});

export const getCityListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_CITY_LIST_FAILURE,
	payload: failureData,
});

export const getCityListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_CITY_LIST_RESPONSE_RESET,
});

export const getCityListResponseChanged = () => ({
	type: GeneralActionTypes.GET_CITY_LIST_RESPONSE_CHANGED,
});
/** ***************** GET CITY END *********************** */

/** ***************** GET PINCODE START *********************** */
export const getPinCodeListStart = (cityData: any) => ({
	type: GeneralActionTypes.GET_PINCODE_LIST_START,
	payload: cityData,
});

export const getPinCodeListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_PINCODE_LIST_SUCCESS,
	payload: successData,
});

export const getPinCodeListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_PINCODE_LIST_FAILURE,
	payload: failureData,
});

export const getPinCodeListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_PINCODE_LIST_RESPONSE_RESET,
});

export const getPinCodeListResponseChanged = () => ({
	type: GeneralActionTypes.GET_PINCODE_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PINCODE END *********************** */

/** ***************** GET DISTRICT START *********************** */
export const getDistrictListStart = (districtData: any) => ({
	type: GeneralActionTypes.GET_DISTRICT_LIST_START,
	payload: districtData,
});

export const getDistrictListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_DISTRICT_LIST_SUCCESS,
	payload: successData,
});

export const getDistrictListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_DISTRICT_LIST_FAILURE,
	payload: failureData,
});

export const getDistrictListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_DISTRICT_LIST_RESPONSE_RESET,
});

export const getDistrictListResponseChanged = () => ({
	type: GeneralActionTypes.GET_DISTRICT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DISTRICT END *********************** */

/** ***************** GET ALL INDUSTRY LIST START *********************** */
export const getAllIndustryListStart = (fetchData: any) => ({
	type: GeneralActionTypes.GET_INDUSTRY_LIST_START,
	payload: fetchData,
});

export const getAllIndustryListSuccess = (fetchSuccess: any) => ({
	type: GeneralActionTypes.GET_INDUSTRY_LIST_SUCCESS,
	payload: fetchSuccess,
});

export const getAllIndustryListFailure = (fetchFailure: any) => ({
	type: GeneralActionTypes.GET_INDUSTRY_LIST_FAILURE,
	payload: fetchFailure,
});

export const getAllIndustryListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_INDUSTRY_LIST_RESPONSE_RESET_START,
});

export const getAllIndustryListResponseChanged = () => ({
	type: GeneralActionTypes.GET_INDUSTRY_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ALL INDUSTRY LIST END *********************** */

/** ***************** GET ALL SUB INDUSTRY LIST START *********************** */
export const getSubIndustryListStart = (fetchData: any) => ({
	type: GeneralActionTypes.GET_SUB_INDUSTRY_LIST_START,
	payload: fetchData,
});

export const getSubIndustryListSuccess = (fetchSuccess: any) => ({
	type: GeneralActionTypes.GET_SUB_INDUSTRY_LIST_SUCCESS,
	payload: fetchSuccess,
});

export const getSubIndustryListFailure = (fetchFailure: any) => ({
	type: GeneralActionTypes.GET_SUB_INDUSTRY_LIST_FAILURE,
	payload: fetchFailure,
});

export const getSubIndustryListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_SUB_INDUSTRY_LIST_RESPONSE_RESET_START,
});

export const getSubIndustryListResponseChanged = () => ({
	type: GeneralActionTypes.GET_SUB_INDUSTRY_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ALL SUB INDUSTRY LIST END *********************** */

/** ***************** FETCH ALL BRANCHES START *********************** */
export const fetchAllBranchesStart = (fetchBranches: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCHES_START,
	payload: fetchBranches,
});

export const fetchAllBranchesSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCHES_SUCCESS,
	payload: successData,
});

export const fetchAllBranchesFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCHES_FAILURE,
	payload: failureData,
});

export const fetchAllBranchesResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCHES_RESPONSE_RESET_START,
});

export const fetchAllBranchesResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCHES_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL BRANCHES END *********************** */

/** ***************** FETCH ALL PURPOSE OF LOAN LIST START *********************** */
export const fetchAllPurposeOfLoanListStart = (purposeOfLoanList: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_START,
	payload: purposeOfLoanList,
});

export const fetchAllPurposeOfLoanListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const fetchAllPurposeOfLoanListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchAllPurposeOfLoanListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET_START,
});

export const fetchAllPurposeOfLoanListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL PURPOSE OF LOAN LIST END *********************** */

/** ***************** FETCH ALL PURPOSE OF LOAN TYPE START *********************** */
export const fetchAllPurposeOfLoanTypeStart = (fetchLoanPurposeType: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_START,
	payload: fetchLoanPurposeType,
});

export const fetchAllPurposeOfLoanTypeSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_SUCCESS,
	payload: successData,
});

export const fetchAllPurposeOfLoanTypeFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_FAILURE,
	payload: failureData,
});

export const fetchAllPurposeOfLoanTypeResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET_START,
});

export const fetchAllPurposeOfLoanTypeResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL PURPOSE OF LOAN TYPE END *********************** */

/** ***************** FETCH ALL BUSINESS LIST START *********************** */
export const fetchAllBusinessListStart = (fetchBusinessList: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_START,
	payload: fetchBusinessList,
});

export const fetchAllBusinessListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_SUCCESS,
	payload: successData,
});

export const fetchAllBusinessListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_FAILURE,
	payload: failureData,
});

export const fetchAllBusinessListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_RESPONSE_RESET_START,
});

export const fetchAllBusinessListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL BUSINESS LIST END *********************** */

/** ***************** FETCH ALL PRODUCT TYPE START *********************** */
export const fetchAllProductTypeStart = (fetchProductTypes: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_START,
	payload: fetchProductTypes,
});

export const fetchAllProductTypeSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_SUCCESS,
	payload: successData,
});

export const fetchAllProductTypeFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_FAILURE,
	payload: failureData,
});

export const fetchAllProductTypeResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_RESPONSE_RESET,
});

export const fetchAllProductTypeResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL PRODUCT TYPE END *********************** */

/** ***************** FETCH ALL PRODUCT LIST START *********************** */
export const fetchAllProductListStart = (fetchProducts: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_START,
	payload: fetchProducts,
});

export const fetchAllProductListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_SUCCESS,
	payload: successData,
});

export const fetchAllProductListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_FAILURE,
	payload: failureData,
});

export const fetchAllProductListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_RESPONSE_RESET,
});

export const fetchAllProductListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_PRODUCT_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL PRODUCT LIST END *********************** */

/** ***************** FETCH ALL OFFICERS BASESD ON BRANCH START *********************** */
export const fetchAllBranchOfficerStart = (fetchBranchOfficer: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_START,
	payload: fetchBranchOfficer,
});

export const fetchAllBranchOfficerSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_SUCCESS,
	payload: successData,
});

export const fetchAllBranchOfficerFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_FAILURE,
	payload: failureData,
});

export const fetchAllBranchOfficerResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_RESPONSE_RESET_START,
});

export const fetchAllBranchOfficerResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL OFFICERS BASESD ON BRANCH END *********************** */

/** ***************** FETCH ALL CENTERS START *********************** */
export const fetchAllCenterListStart = (fetchCenter: any) => ({
	type: GeneralActionTypes.FETCH_ALL_CENTERS_START,
	payload: fetchCenter,
});

export const fetchAllCenterListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_CENTERS_SUCCESS,
	payload: successData,
});

export const fetchAllCenterListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_CENTERS_FAILURE,
	payload: failureData,
});

export const fetchAllCenterListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_CENTERS_RESPONSE_RESET_START,
});

export const fetchAllCenterListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_CENTERS_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL CENTERS END *********************** */

/** ***************** FETCH CENTER GROUPS START *********************** */
export const fetchCenterGroupListStart = (fetchGroup: any) => ({
	type: GeneralActionTypes.FETCH_CENTER_GROUPS_START,
	payload: fetchGroup,
});

export const fetchCenterGroupListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_CENTER_GROUPS_SUCCESS,
	payload: successData,
});

export const fetchCenterGroupListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_CENTER_GROUPS_FAILURE,
	payload: failureData,
});

export const fetchCenterGroupListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_CENTER_GROUPS_RESPONSE_RESET_START,
});

export const fetchCenterGroupListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_CENTER_GROUPS_RESPONSE_CHANGED,
});
/** ***************** FETCH CENTER GROUPS END *********************** */

/** ***************** FETCH GROUP MEMBER START *********************** */
export const fetchGroupMemberListStart = (fetchGroupMembers: any) => ({
	type: GeneralActionTypes.FETCH_GROUP_MEMBERS_START,
	payload: fetchGroupMembers,
});

export const fetchGroupMemberListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_GROUP_MEMBERS_SUCCESS,
	payload: successData,
});

export const fetchGroupMemberListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_GROUP_MEMBERS_FAILURE,
	payload: failureData,
});

export const fetchGroupMemberListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_GROUP_MEMBERS_RESPONSE_RESET_START,
});

export const fetchGroupMemberListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_GROUP_MEMBERS_RESPONSE_CHANGED,
});
/** ***************** FETCH CENTER GROUPS END *********************** */

/** ***************** FETCH ALL INVESTOR START *********************** */
export const fetchAllInverstorListStart = (fetchCenter: any) => ({
	type: GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_START,
	payload: fetchCenter,
});

export const fetchAllInverstorListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_SUCCESS,
	payload: successData,
});

export const fetchAllInverstorListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_FAILURE,
	payload: failureData,
});

export const fetchAllInverstorListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_RESPONSE_RESET_START,
});

export const fetchAllInverstorListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL INVESTOR END *********************** */

/** ***************** FETCH ALL GROUP ***************** */
export const fetchAllGroupListStart = (getData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_GROUP_LIST_START,
	payload: getData,
});

export const fetchAllGroupListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_GROUP_LIST_SUCCESS,
	payload: successData,
});

export const fetchAllGroupListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_ALL_GROUP_LIST_FAILURE,
	payload: failureData,
});

export const fetchAllGroupListResponseReset = () => ({
	type: GeneralActionTypes.FETCH_ALL_GROUP_LIST_RESPONSE_RESET,
});

export const fetchAllGroupListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_ALL_GROUP_LIST_RESPONSE_CHANGED,
});

/** ***************** FETCH BRANCHE ACCOUNT LIST START *********************** */
export const fetchBranchAccountListStart = (fetchBranches: any) => ({
	type: GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_START,
	payload: fetchBranches,
});

export const fetchBranchAccountListSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const fetchBranchAccountListFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const fetchBranchAccountListResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_RESET_START,
});

export const fetchBranchAccountListResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL BRANCHES END *********************** */

/** ***************** FETCH LOAN INDEX BASED ON GROUP START *********************** */
export const fetchGroupLoanIndexStart = (fetchGroupMembers: any) => ({
	type: GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_START,
	payload: fetchGroupMembers,
});

export const fetchGroupLoanIndexSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_SUCCESS,
	payload: successData,
});

export const fetchGroupLoanIndexFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_FAILURE,
	payload: failureData,
});

export const fetchGroupLoanIndexResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_RESET_START,
});

export const fetchGroupLoanIndexResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_CHANGED,
});
/** ***************** FETCH LOAN INDEX BASED ON GROUP END *********************** */

/** ***************** FETCH LOAN INDEX BY SEARCH START *********************** */
export const fetchSearchLoanIndexStart = (fetchGroupMembers: any) => ({
	type: GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_START,
	payload: fetchGroupMembers,
});

export const fetchSearchLoanIndexSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const fetchSearchLoanIndexFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const fetchSearchLoanIndexResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_RESPONSE_RESET_START,
});

export const fetchSearchLoanIndexResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** FETCH LOAN INDEX BY SEARCH END *********************** */

/** ***************** FETCH VERSION START *********************** */
export const fetchVersionStart = (credential: any) => ({
	type: GeneralActionTypes.FETCH_VERSION_START,
	payload: credential,
});

export const fetchVersionSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_VERSION_SUCCESS,
	payload: successData,
});

export const fetchVersionFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_VERSION_FAILURE,
	payload: failureData,
});

export const fetchVersionResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_VERSION_RESPONSE_RESET,
});

export const fetchVersionResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_VERSION_RESPONSE_CHANGED,
});
/** ***************** FETCH VERSION END *********************** */

/** ***************** UPDATE VERSION START *********************** */
export const updateVersionStart = (credential: any) => ({
	type: GeneralActionTypes.UPDATE_VERSION_START,
	payload: credential,
});

export const updateVersionSuccess = (successData: any) => ({
	type: GeneralActionTypes.UPDATE_VERSION_SUCCESS,
	payload: successData,
});

export const updateVersionFailure = (failureData: any) => ({
	type: GeneralActionTypes.UPDATE_VERSION_FAILURE,
	payload: failureData,
});

export const updateVersionResponseResetStart = () => ({
	type: GeneralActionTypes.UPDATE_VERSION_RESPONSE_RESET,
});

export const updateVersionResponseChanged = () => ({
	type: GeneralActionTypes.UPDATE_VERSION_RESPONSE_CHANGED,
});
/** ***************** UPDATE VERSION END *********************** */

/** ***************** FETCH PINCODE DETAILS START *********************** */
export const fetchPincodeDetailsStart = (credential: any) => ({
	type: GeneralActionTypes.FETCH_PINCODE_DETAILS_START,
	payload: credential,
});

export const fetchPincodeDetailsSuccess = (successData: any) => ({
	type: GeneralActionTypes.FETCH_PINCODE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchPincodeDetailsFailure = (failureData: any) => ({
	type: GeneralActionTypes.FETCH_PINCODE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchPincodeDetailsResponseResetStart = () => ({
	type: GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_RESET,
});

export const fetchPincodeDetailsResponseChanged = () => ({
	type: GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH PINCODE DETAILS END *********************** */

/** ***************** GENERIC PINCODE DETAILS START *********************** */
export const genericPincodeDetailsStart = (fieldType: string, credential: any) => ({
	type: GeneralActionTypes.GENERIC_PINCODE_DETAILS_START,
	payload: { fieldType, ...credential },
});

export const genericPincodeDetailsSuccess = (fieldType: string, successData: any) => ({
	type: GeneralActionTypes.GENERIC_PINCODE_DETAILS_SUCCESS,
	payload: { fieldType, successData },
});

export const genericPincodeDetailsFailure = (fieldType: string, errorData: any) => ({
	type: GeneralActionTypes.GENERIC_PINCODE_DETAILS_FAILURE,
	payload: { fieldType, errorData },
});

export const genericPincodeDetailsResponseReset = (fieldType: string) => ({
	type: GeneralActionTypes.GENERIC_PINCODE_DETAILS_RESPONSE_RESET,
	payload: { fieldType },
});

export const genericPincodeDetailsResponseChanged = (fieldType: string) => ({
	type: GeneralActionTypes.GENERIC_PINCODE_DETAILS_RESPONSE_CHANGED,
	payload: { fieldType },
});
/** ***************** GENERIC PINCODE DETAILS END *********************** */

/** ***************** Get Location List based on Level START *********************** */
export const getLocationListBasedLevelStart = (cityData: any) => ({
	type: GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_START,
	payload: cityData,
});

export const getLocationListBasedLevelSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_SUCCESS,
	payload: successData,
});

export const getLocationListBasedLevelFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_FAILURE,
	payload: failureData,
});

export const getLocationListBasedLevelResponseResetStart = () => ({
	type: GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_RESET,
});

export const getLocationListBasedLevelResponseChanged = () => ({
	type: GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_CHANGED,
});
/** ***************** Get Location List based on Level END *********************** */

/** ***************** CHECK GOOGLE AUTHENTICATION START *********************** */
export const checkGoogleAuthenticationStart = (credential: any) => ({
	type: GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_START,
	payload: credential,
});

export const checkGoogleAuthenticationSuccess = (successData: any) => ({
	type: GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_SUCCESS,
	payload: successData,
});

export const checkGoogleAuthenticationFailure = (failureData: any) => ({
	type: GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_FAILURE,
	payload: failureData,
});

export const checkGoogleAuthenticationResponseResetStart = () => ({
	type: GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_RESPONSE_RESET,
});

export const checkGoogleAuthenticationResponseChanged = () => ({
	type: GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_RESPONSE_CHANGED,
});
/** ***************** CHECK GOOGLE AUTHENTICATION END *********************** */

/** ***************** Get Purpose Of Laon List START *********************** */
export const getPurposeOfLoanProposalListStart = (purposeofloanProposalData: any) => ({
	type: GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_START,
	payload: purposeofloanProposalData,
});

export const getPurposeOfLoanProposalListSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_SUCCESS,
	payload: successData,
});

export const getPurposeOfLoanProposalListFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_FAILURE,
	payload: failureData,
});

export const getPurposeOfLoanProposalListResponseResetStart = () => ({
	type: GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
});

export const getPurposeOfLoanProposalListResponseChanged = () => ({
	type: GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED,
});
/** ***************** Get Purpose Of Loan List END *********************** */

/** ***************** Get Officer Based On Level List START *********************** */
export const getOfficerBesedOnLevelListProposalStart = (officerbesedonlevelData: any) => ({
	type: GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_START,
	payload: officerbesedonlevelData,
});

export const getOfficerBesedOnLevelListProposalSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_SUCCESS,
	payload: successData,
});

export const getOfficerBesedOnLevelListProposalFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_FAILURE,
	payload: failureData,
});

export const getOfficerBesedOnLevelListProposalResponseResetStart = () => ({
	type: GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_RESET,
});

export const getOfficerBesedOnLevelListProposalResponseChanged = () => ({
	type: GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** Get Officer Based On Level List END *********************** */

/** ***************** Get THRIFT for Loan Proposal START *********************** */
export const getThriftListProposalStart = (thriftData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_START,
	payload: thriftData,
});

export const getThriftListProposalSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_SUCCESS,
	payload: successData,
});

export const getThriftListProposalFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_FAILURE,
	payload: failureData,
});

export const getThriftListProposalResponseResetStart = () => ({
	type: GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_RESPONSE_RESET,
});

export const getThriftListProposalResponseChanged = () => ({
	type: GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** Get THRIFT for Loan Proposal END *********************** */

/** ***************** Get THRIFT for Loan Proposal START *********************** */
export const getThriftDetailsStart = (thriftData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_DETAILS_START,
	payload: thriftData,
});

export const getThriftDetailsSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_DETAILS_SUCCESS,
	payload: successData,
});

export const getThriftDetailsFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_DETAILS_FAILURE,
	payload: failureData,
});

export const getThriftDetailsResponseResetStart = () => ({
	type: GeneralActionTypes.GET_THRIFT_DETAILS_RESPONSE_RESET,
});

export const getThriftDetailsResponseChanged = () => ({
	type: GeneralActionTypes.GET_THRIFT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** Get THRIFT for Loan Proposal END *********************** */

/** ***************** Get THRIFT for Loan Proposal START *********************** */
export const getThriftTwoDetailsStart = (thriftData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_TWO_DETAILS_START,
	payload: thriftData,
});

export const getThriftTwoDetailsSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_TWO_DETAILS_SUCCESS,
	payload: successData,
});

export const getThriftTwoDetailsFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_THRIFT_TWO_DETAILS_FAILURE,
	payload: failureData,
});

export const getThriftTwoDetailsResponseResetStart = () => ({
	type: GeneralActionTypes.GET_THRIFT_TWO_DETAILS_RESPONSE_RESET,
});

export const getThriftTwoDetailsResponseChanged = () => ({
	type: GeneralActionTypes.GET_THRIFT_TWO_DETAILS_RESPONSE_CHANGED,
});
/** ***************** Get THRIFT for Loan Proposal END *********************** */

/** ***************** Get ALL NON MEMBERS for Loan Proposal START *********************** */
export const getNonApproveMembersDetailsStart = (getData: any) => ({
	type: GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_START,
	payload: getData,
});

export const getNonApproveMembersDetailsSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_SUCCESS,
	payload: successData,
});

export const getNonApproveMembersDetailsFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_FAILURE,
	payload: failureData,
});

export const getNonApproveMembersDetailsResponseResetStart = () => ({
	type: GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_RESET,
});

export const getNonApproveMembersDetailsResponseChanged = () => ({
	type: GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** Get ALL NON MEMBERS for Loan Proposal END *********************** */

/** ***************** GET TODAY GOLG PRICE START *********************** */
export const getTodayGoldPriceStart = (getData: any) => ({
	type: GeneralActionTypes.GET_TODAY_GOLD_PRICE_START,
	payload: getData,
});

export const getTodayGoldPriceSuccess = (successData: any) => ({
	type: GeneralActionTypes.GET_TODAY_GOLD_PRICE_SUCCESS,
	payload: successData,
});

export const getTodayGoldPriceFailure = (failureData: any) => ({
	type: GeneralActionTypes.GET_TODAY_GOLD_PRICE_FAILURE,
	payload: failureData,
});

export const getTodayGoldPriceResponseResetStart = () => ({
	type: GeneralActionTypes.GET_TODAY_GOLD_PRICE_RESPONSE_RESET,
});

export const getTodayGoldPriceResponseChanged = () => ({
	type: GeneralActionTypes.GET_TODAY_GOLD_PRICE_RESPONSE_CHANGED,
});
/** ***************** GET TODAY GOLG PRICE END *********************** */

/** ***************** UPDATE TODAY GOLG PRICE START *********************** */
export const updateTodayGoldPriceStart = (getData: any) => ({
	type: GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_START,
	payload: getData,
});

export const updateTodayGoldPriceSuccess = (successData: any) => ({
	type: GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_SUCCESS,
	payload: successData,
});

export const updateTodayGoldPriceFailure = (failureData: any) => ({
	type: GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_FAILURE,
	payload: failureData,
});

export const updateTodayGoldPriceResponseResetStart = () => ({
	type: GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_RESPONSE_RESET,
});

export const updateTodayGoldPriceResponseChanged = () => ({
	type: GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_RESPONSE_CHANGED,
});
/** ***************** UPDATE TODAY GOLG PRICE END *********************** */

/** ***************** GET BRANCHES FORM STATES START /** ***************** */
export const GetStatewiseBranchesStart = (addData: any) => ({
	type: GeneralActionTypes.GET_STATEWISW_BRANCHES_START,
	payload: addData,
});
export const GetStatewiseBranchesSuccess = (addData: any) => ({
	type: GeneralActionTypes.GET_STATEWISW_BRANCHES_SUCCESS,
	payload: addData,
});
export const GetStatewiseBranchesFailure = (addData: any) => ({
	type: GeneralActionTypes.GET_STATEWISW_BRANCHES_FAILURE,
	payload: addData,
});
export const GetStatewiseBranchesResponceReset = () => ({
	type: GeneralActionTypes.GET_STATEWISW_BRANCHES_RESPONSE_RESET,
});
export const GetStatewiseBranchesResponceChanged = () => ({
	type: GeneralActionTypes.GET_STATEWISW_BRANCHES_RESPONSE_CHANGED,
});
/* ***************** GET BRANCHES FORM STATES END /** ******************/
